export default "__VITE_ASSET__Bjujz5BL__"